<template>
  <div class="manageTab">
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        label="基本信息"
        name="first"
      >
        <basicInfo></basicInfo>
      </el-tab-pane>
      <el-tab-pane
        label="商品图片"
        :disabled="true"
        name="second"
      >
        <basic-img></basic-img>
      </el-tab-pane>
      <el-tab-pane
        label="规格属性"
        :disabled="true"
        name="third"
      >
        <basic-attribute></basic-attribute>
      </el-tab-pane>
      <el-tab-pane
        label="商品详情页面"
        :disabled="true"
        name="fourth"
      >定时任务补偿</el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import basicInfo from '@/components/basic/goodsmanage/basic-info'
import basicAttribute from '@/components/basic/goodsmanage/basic-attribute'
import basicImg from '@/components/basic/goodsmanage/basic-img'
export default {
  components: { basicInfo, basicAttribute, basicImg },
  data () {
    return {
      activeName: 'first'
    }
  },
  methods: {
    handleClick (tab, event) {
    }
  }
}
</script>
<style lang="scss">
.manageTab {
  padding: 10px 0 0 0;
  .el-tabs__item {
    width: 90px;
    text-align: center;
    background-color: #73818d;
    color: #fff;
    border-radius: 10px 10px 0 0px;
    margin-right: 1px;
    line-height: 30px;
    height: 30px;
    padding: 0;
  }
  .el-form {
    border: none;
  }
  .el-tabs__item.is-active {
    background-color: #a4b4c1;
    color: #fff;
  }
  .el-tabs__active-bar {
    display: none;
  }
  .el-tabs__item:hover {
    background-color: #a4b4c1;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/goodsmanage/manage-tab.vue